/*eslint-disable */
import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import { useParams } from "react-router-dom";
import OtrosVehiculosComponent from "../components/vehiculos-detail/otros-vehiculos.component";
import BannerComponent from "../components/pqr/banner.component";
import ContenidoComponent from "../components/pqr/contenido.component";
import ModalComponent from "../components/posventa/campania/modal.component";
import { Link } from "react-router-dom";

const PQRPage: React.FC = () => {
  const { category } = useParams<{ category?: string }>();
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => setModalOpen(true);
  const handleCloseModal = () => setModalOpen(false);

  return (
    <>
      <MenuLayouts
        className="home-page"
        active="somos"
        setVisibleHeight={setVisibleHeight}
        visibleHeight={visibleHeight}
      />
      <div
        className="home-page" /* style={{backgroundColor: "#F6F3F2", height: "100vh"}} */
      >
        <h1
          style={{ position: "absolute", opacity: "0", pointerEvents: "none" }}
        >
          Peticiones, Quejas y Reclamos - Hyundai Colombia
        </h1>

        <div className="home-page-mascara"></div>
        <BannerComponent />
        <ContenidoComponent handleOpenModal={handleOpenModal} />
        <OtrosVehiculosComponent />
        <ModalComponent isOpen={isModalOpen} onClose={handleCloseModal}>
          <div className="alert">
            <div className="title">Solicitud recibida</div>
            <div className="description">
              Pronto un asesor se pondrá en contacto contigo.
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <button onClick={handleCloseModal} className="close-button">
              Regresar
            </button>
            <Link
              to={"/"}
              onClick={handleCloseModal}
              className="agendar-button"
            >
              Ir al Home
            </Link>
          </div>
        </ModalComponent>
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default PQRPage;
